import { PlayerCourseSetup } from '@hendrx/core/courses';
import { createFileRoute, Outlet, useParams } from '@tanstack/react-router';

export const Route = createFileRoute('/player/courses/$courseDraftIdentifier')({
  component: PlayerCourseLayout
});

function PlayerCourseLayout() {
  const params = useParams({ strict: false });

  if (!params.courseDraftIdentifier) {
    return null;
  }

  return (
    <PlayerCourseSetup
      activityId={params.activityId}
      categoryId={params.categoryId}
      courseDraftIdentifier={params.courseDraftIdentifier}
    >
      <Outlet />
    </PlayerCourseSetup>
  );
}
